import AdvancedSearchPanel from "./AdvancedSearchPanel";

export default AdvancedSearchPanel;